import React from 'react';
import { Empty, Scrollbar, theme } from 'codeArt/components/Base';
import Portal from 'codeArt/components/Portal';
import { AreaChart, BarSpreadChart, ChartYHanle, ScatterChart } from './common';
import { Util, runtime } from 'codeArt/common';

export class StopHistoryChart extends BarSpreadChart {

    constructor(props) {
        super(props);
    }

    differDay(start, end) {
        let diff = end.getTime() / 1000 - parseInt(start / 1000);
        return parseInt(diff / 60 / 60 / 24);
    }

    addMinutes(v, m) {
        let temp = new Date(v);
        let time = temp.setMinutes(temp.getMinutes() + m);
        return new Date(time);
    }

    dateFormat(fmt, date) {
        let ret;
        const opt = {
            "Y+": date.getFullYear().toString(),        // 年
            "m+": (date.getMonth() + 1).toString(),     // 月
            "d+": date.getDate().toString(),            // 日
            "H+": date.getHours().toString(),           // 时
            "M+": date.getMinutes().toString(),         // 分
            "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            };
        };
        return fmt;
    }

    getDate(arry, value, name, hide) {
        let { start, end, interval, day } = this.getTimeInfo();
        let on = this.addMinutes(start, interval * arry[0]);
        let off = this.addMinutes(start, interval * arry[1]);

        let sameDay = on.getFullYear() == off.getFullYear() && on.getMonth() == off.getMonth() && on.getDate() == off.getDate();
        if (sameDay) {
            value = `${this.dateFormat("mm/dd HH:MM", on)} - ${this.dateFormat("HH:MM", off)}`;
        } else {
            value = `${this.dateFormat("mm/dd HH:MM", on)} - ${this.dateFormat("mm/dd HH:MM", off)}`;
        }

        name = hide ? "运行中" : name;
        return { value, name };
    }

    getTimeInfo() {
        let { data, arg } = this.props;
        arg = arg || {};
        let start = arg.startDate;
        let end = arg.endDate;
        start = start ? new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0, 0) : new Date();
        end = end ? new Date(end.getFullYear(), end.getMonth(), end.getDate(), 0, 0, 0, 0) : new Date();
        let day = this.differDay(start, end);

        day = day + 1;//加上一天 包括今天 计算出 一共多少天的时间数据
        let interval = day * 24 * 60 / 10; //得到10个x坐标 每个坐标多少分钟

        return { start, end, interval, day };
    }

    mapXValue(v) {
        let { start, end, interval } = this.getTimeInfo();
        let time = v ? this.addMinutes(start, interval * v) : start;
        time = this.dateFormat("mm-dd HH:MM", time);
        return time;
    }

    getX() {
        return { format: (v) => { return this.mapXValue(v); } };
    }

    getGrid() {
        if (runtime.mobile) {
            return { left: '0', right: '0', bottom: '20' };
        }
        else{
            return { left: '15', right: '35', bottom: '20' };
        }
    }
}

export class RunBarChart extends AreaChart {

    constructor(props) {
        super(props);
        this.title = "跑条 每百万";
        this.unit = "次数";
        /*   this.yName = "生产[x1000支]"; */
        this.yHanle = ChartYHanle.numerical;
    }

    getX() {
        return ["100W", "200W", "300W", "400W", "500W"];
    }

    getGrid() {
        if (runtime.mobile){
            return {left: '5', right: '0'}
        } 
    }
}